import {
  AfterContentChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output, Renderer2, SimpleChanges,
} from '@angular/core';
import {Slide} from "../../models/Story/Slide";
import {EnvironmentConfig} from "../../models/Story/EnvironmentConfig";
import {ImageryProviderService} from "../../services/imageryProvider/imagery-provider.service";
import {SlideConfig} from "../../models/Story/SlideConfig";
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";
import {ItemManagerService} from "../../services/itemManager/item-manager.service";
import {HttpClient} from "@angular/common/http";
import {saveAs} from "file-saver";
import {DrawingEditorToolsComponent21} from "../drawing-editor-tools/drawing-editor-tools.component";
import {Story} from "../../models/Story/Story";
import {BehaviorSubject, fromEvent, interval, Observable, Subject, timer} from 'rxjs';
import {EsBsModalService} from "../../services/bsModalService/bs-modal.service";
import {ToolsService} from "../../services/toolsService/tools.service";
import {StoryService} from "../../services/storyService/story.service";
import {PreloadService} from "../../services/preloadService/preload.service";
import {ConcreteLayerService} from "../../services/concreteLayer/concrete-layer.service";
import {OverlayService} from "../../services/overlay/overlay.service";
import {isDisableGenerationStatus} from "../../../configs/view_only";
import { GroupService } from '@src/app/services/groupService/group-service.service';
import { Group } from '@src/app/classes/Groups/Group';
import { NearmapService } from '@src/app/services/nearmap/nearmap.service';
import { Overlay } from '@angular/cdk/overlay';
import { OverlayType2 } from '@src/app/services/overlay/OverlayType2';
// import { Overlay } from 'src/app/services/overlay/Overlay';
// import { OverlayType2 } from 'src/app/services/overlay/OverlayType2';
// import { Group } from 'src/app/classes/Groups/Group';
// import { FixedLayersService } from 'src/app/services/fixedLayers/fixed-layers.service';
// import { GroupService } from 'src/app/services/groupsService/group.service';
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";
import PerfectScrollbar from 'perfect-scrollbar';
import {position} from 'html2canvas/dist/types/css/property-descriptors/position';
import {debounceTime} from 'rxjs/operators';
declare var Yiit;
declare var $;

@Component({
  selector: 'app-story-slides',
  templateUrl: './story-slides.component.html',
  styleUrls: ['./story-slides.component.scss'],
})

export class StorySlidesComponent implements OnInit, AfterViewInit, AfterContentChecked {

  @Output() closedState = new EventEmitter();
  @Output() openedState = new EventEmitter();
  public Yiit = Yiit;
  public editingListPosition: {top:string, left:string};
  get slides(): Slide[] {
    return this.currentStory ? this.currentStory.slides : [];
  }
  // public stories : Story[] = [];
  public pptxMap : Map<string, any> = new Map<string, any>();
  public groups : any[] = [];
  public currentSlide : Slide = null;
  public opened = false;
  public openedFully = false;
  public openedSearch = false;
  public activeTab = '';
  public isOpenedEditList = false;
  public openedStory = null;

  private backupConfig:SlideConfig = null;
  private environmentComponents = ['imageryProviderService', 'concreteLayerService', 'overlayService', 'itemManagerService'];

  private presentationId;
  private presentationImages;

  public sidebarOpened = false;
  public isDisabled = false;
  public previewImage = null;
  public previewSlide = null;
  public stories: Story[] = [];
  public currentStory: Story;
  public currentGroup: any = null;
  public state = 'default';
  public showCaptureBtn = false;
  public downloadedTooltipVisible = false;
  public groupTooltipVisible = false;
  public copiedTooltipVisible = false;
  public storySearchPhrase = '';
  public presentationsInGeneration = [];
  public isEditableStoryArr = [];
  public isScreenshotCreated = false;
  public overlayImages:Overlay[] = [];
  public overlaysType2:OverlayType2[] = [];

  private groupVisibility:any = {};
  private groupVisibilityTimeout:any = false;
  private imageryProviderName:any = false;
  private imageryProviderMode:any = false;
  private prevSelectedModeVal: any = null;
  private prevSelectedModeName:any = null;
  private inputKeyUpTimer:any = false;

  scrollbars:any[] = [];
  //public showExportProgress: Observable<boolean>;
  //public showExportProgressBS = new BehaviorSubject<boolean>(true);

  private destroy$: Subject<boolean> = new Subject<boolean>();

  private ITEM_VISIBILITY_COMPONENT_NAME = 'PlacedItemsFilter';

  constructor(
    private imageryProviderService:ImageryProviderService,
    private cesiumAdapterService:CesiumAdapterService,
    private itemManagerService:ItemManagerService,
    private concreteLayerService:ConcreteLayerService,
    private overlayService:OverlayService,
    private httpClient: HttpClient,
    private cd: ChangeDetectorRef,
    private bsModal: EsBsModalService,
    private toolsService: ToolsService,
    private storyAdapter: StoryService,
    private preload: PreloadService,
    //private fl: FixedLayersService,
    private concreteLayer: ConcreteLayerService,
    private gs: GroupService,
    private nearmapService: NearmapService,
    private renderer: Renderer2
    // private fixedLayerAdapter: FixedLayersService,
  ) {
    window['oneplanActivateSlide'] = async (storyId, slideIndex, slideInformation) => {
      if (!storyId) {
        let slide = Slide.fromConfig(slideInformation);
        this.applyConfig(slide.config);
        return;
      }
      for (let i = 0; i < this.storyAdapter.stories.length; i++) {
        let story = this.storyAdapter.stories[i];
        if (story.id == storyId) {
          this.applyConfig(story.slides[slideIndex].config);
          break;
        }
      }
    };

    window['oneplanSetItemsZoomLevelHeights'] = (zoomLevelHeights) => {
      this.cesiumAdapterService.itemsManager.setZoomLevelHeights(zoomLevelHeights);
    };

    window['oneplanSetItemsSizeScale'] = (scale) => {
      this.cesiumAdapterService.itemsManager.setSizeScale(scale);
    };

    window['oneplanActivateSlideAsync'] = (storyId, slideIndex, slideInformation, delay = 10) => {
      return new Promise(async (resolve, reject) => {
        if (!storyId || storyId == '0' || storyId == 0) {
          let slide = Slide.fromConfig(slideInformation);

          if (slide.config.environment.zoomLevel != false){
            this.cesiumAdapterService.overridedZoomValue = slide.config.environment.zoomLevel;
          }
          //this.applyConfig(slide.config);
          await this.applyConfigAsync(slide.config);
          setTimeout(() => {
            resolve(true);
            setTimeout(()=>{
              this.cesiumAdapterService.overridedZoomValue = null
            }, 500);
          }, delay);
          return;
        }
        for (let i = 0; i < this.storyAdapter.stories.length; i++) {
          let story = this.storyAdapter.stories[i];
          if (story.id == storyId) {
            // this.applyConfig(story.slides[slideIndex].config);
            if (story.slides[slideIndex].config.environment.zoomLevel != false){
              this.cesiumAdapterService.overridedZoomValue = story.slides[slideIndex].config.environment.zoomLevel;
            }
            await this.applyConfigAsync(story.slides[slideIndex].config);
            setTimeout(() => {
              resolve(true);
              setTimeout(()=>{
                this.cesiumAdapterService.overridedZoomValue = null
              }, 500);
            }, delay);
            return;
          }
        }
      });
    };

    window['oneplanGetSlideLegend'] = (storyId, slideIndex, slideInformation) => {
      if (!storyId) {
        let slide = Slide.fromConfig(slideInformation);
        this.getLegendImageForSlide(slide, (im) => {
          window['oneplanSlideLegend'] = im;
        }, true);
        return;
      }
      for (let i = 0; i < this.storyAdapter.stories.length; i++) {
        let story = this.storyAdapter.stories[i];
        if (story.id == storyId) {
          this.getLegendImageForSlide(story.slides[slideIndex], (im) => {
            window['oneplanSlideLegend'] = im;
          }, true);
          break;
        }
      }
    };

    // window['oneplanGetCurrentBounds'] = () => {
    //   return this.cesiumAdapterService.getViewRectangle();
    //   /*window['oneplanCurrentBoundsValue'] = null;
    //   new Promise((resolve) => {
    //     let e = this.getCurrentConfig();
    //     e.boundsready.subscribe(async (bounds) => {
    //       if (bounds) {
    //         window['oneplanBoundsValue'] = e.bounds;
    //         resolve(e);
    //       }
    //     });
    //   });*/
    // };
  }



  // get getShowExportProgressTrue() {
  //   this.showExportProgressBS.next(true);
	// 	return this.showExportProgressBS.asObservable();
	// }
  // get getShowExportProgressFalse() {
	// 	this.showExportProgressBS.next(false);
	// 	return this.showExportProgressBS.asObservable();
	// }

  get filteredStories() {
    return this.storyAdapter.stories.filter((s) => {
      return (!this.storySearchPhrase  || (s.hasOwnProperty('name') && s.name.toLowerCase().indexOf(this.storySearchPhrase.toLowerCase()) >= 0));
    });
  }

  ngAfterContentChecked() {
    jQuery('.slide-menu').dropdown();
  }

  ngOnInit() {
    fromEvent(window, 'resize')
      .pipe(
        debounceTime(100)
      ).subscribe(()=> {
      this.updateSliders();
    });

    // setTimeout(() => {
    //   this.showExportProgress = this.getShowExportProgressTrue;
    //   console.log('this.showExportProgress = this.getShowExportProgressTrue;');
    // }, 2000);


    if (window.hasOwnProperty('STORIES')) {
      let story = window['STORIES'];
      story = story.map((_story)=>{
        if (_story.hasOwnProperty('slides')
          && Array.isArray(_story.slides) && _story.slides.length > 0
          && _story.slides[0].hasOwnProperty('image')) {
          return Story.fromConfig(_story);
        }
        return _story;
      });

      this.initStoriesId(story);

      this.storyAdapter.storiesUpdated$.subscribe((stories:Story[])=>{
        this.stories = stories;
        if (this.stories.length > 0){
          this.isScreenshotCreated = true;
        }
        if (!this.currentStory){
          this.currentStory = this.stories[0];
          this.cd.detectChanges();
        }
        this.reInitCurrentStory();
        if (!this.currentStory){
          if (this.stories.length === 0) {
            this.setState('default');
          } else {
            this.currentStory = this.stories[0];
            this.reInitCurrentStory();
          }
        }
        this.cd.detectChanges();
      });

      this.storyAdapter.currentStory$.subscribe((story:Story)=>{
        if (story){
          this.currentStory = story;
          this.reInitCurrentStory();
          this.cd.detectChanges();
        }
      });

      this.storyAdapter.stories = story;

      this.storyAdapter.isScreenshotCreated$.subscribe((val:any)=>{
        this.isScreenshotCreated = val;
        this.setState('stories');
        this.activeTab = 'stories';
        this.cd.detectChanges();
      });

      this.storyAdapter.changeStoryTabStatus$.subscribe((val:boolean)=>{
        this.toggleStories(val);
      })
      this.imageryProviderService.selectedModeChanged.subscribe((val:any)=>{
        this.imageryProviderName = val.name;
        this.imageryProviderMode = val.mode;
      })
    }
    this.initPPtx();
    this.initGroups();
    this.checkGeneratingPresentations();
    this.overlayService.getOverlayImages().subscribe((overlayImgs:Overlay[])=>{
      this.overlayImages = overlayImgs;
    });
    this.overlayService.getOverlaysType2().subscribe((overlayImgs:OverlayType2[])=>{
      this.overlaysType2 = overlayImgs;
    });
  }

  private updateSliders(){
    this.scrollbars.forEach((ps)=>{
      ps.update();
    });
    this.cd.detectChanges();
  }

  private checkGeneratingPresentations(){
    interval(1000*60).subscribe(()=>{
      this.sendCheckGenerationRequest();
    })
  }

  private sendCheckGenerationRequest(){
    if (!isDisableGenerationStatus) {
      this.httpClient.get('/story/generation-status', {
        params: {
          event_id: window['EVENT_ID']
        }
      }).subscribe((result) => {
        console.log('generation-status result', result);
        let pending:any = result && typeof result['pending'] !== 'undefined' ? result['pending'] : [];
        //this.showExportProgress = this.getShowExportProgressTrue;
        //console.log('this.showExportProgress', this.showExportProgress);
      })
    }
  }

  private initPPtx(){
    let personalConfig = window['PERSONAL_CONFIG'];
    let keys = Object.keys(personalConfig);
    keys.forEach((key)=>{
      if (key.indexOf('story-pptx') >= 0){
        this.pptxMap.set(key.substr(key.lastIndexOf('-')+1, key.length), personalConfig[key]);
      }
    })
  }

  private initStoriesId(story){
    if (Array.isArray(story)){
      let index = 0;
      let isChanged = false;
      story.forEach((_story)=>{
        if (!_story.hasOwnProperty('id')){
          _story.id = index;
          index++;
          isChanged = true;
        }
      });

      if (isChanged){
        this.saveStory()
      }
    }
  }

  public createGroup(){
    this.groups.push({name: 'Group '+this.groups.length, id: this.groups.length+1, stories: []});
  }
  toggleToGroup(story:Story){
    if (this.currentGroup){
      if (this.currentGroup.stories.includes(story)){
        this.currentGroup.stories.splice(this.currentGroup.stories.indexOf(story), 1);
        story.groupId = null;
        story.groupName = null;
      }
      else{
        this.currentGroup.stories.push(story);
        story.groupId = this.currentGroup.id;
        story.groupName = this.currentGroup.name;
      }
      return;
    }
    throw new Error('Can\'t add to current group. Because group is undefined');
  }

  private initGroups(){
    this.storyAdapter.stories.forEach((_story)=>{
      if (_story.groupId != null){
        if (!this.hasGroup(_story.groupId)){
          this.groups.push({name: _story.groupName, id: _story.groupId, stories: [_story]});
        }
        else {
          let group = this.getGroupById(_story.groupId);
          if (group){
            group.stories.push(_story);
          }
        }
      }
    })
  }

  private hasGroup(id){
    for (let i = 0; i < this.groups.length; i++){
      if (this.groups[i].id === id){
        return true;
      }
    }
    return false;
  }

  isStoryInCurrentGroup(_story:Story){
    if (this.currentGroup === null){
      return false;
    }
    return _story.groupId === this.currentGroup.id;
  }

  private getGroupById(id){
    for (let i = 0; i < this.groups.length; i++){
      if (this.groups[i].id === id){
        return this.groups[i];
      }
    }
    return null;
  }

  getGroupPreviewImage(group){
    return group.stories.length && group.stories[0].slides && group.stories[0].slides.length > 0 ? group.stories[0].slides[0].image : null;
  }

  setBarWidth(){
    var windowWidth = window.innerWidth;
    var drawingToolBarWidth = document.getElementsByClassName('drawing-tool-wrapper');
    // this.barWidth = windowWidth - drawingToolBarWidth;
  }

  get slidesSorted () {
    return this.slides.slice().sort((a, b) => a.sort - b.sort);
  }

  setState (state) {
    this.state = state;
    if (state === 'default') {
      this.closedState.emit(true);
    } else {
      this.openedState.emit(true);

      // this.checkScrollbars('.story .full-content');
      this.checkScrollbars('.story-header');
      this.checkScrollbars('.es-slides-story-container .es-wrapper-container .es-wrapper');

    }

    if (this.state != 'group'){this.currentGroup = null;}
  }

  setGroupTabVisibility(flag){
    this.state = (flag) ? 'group' : 'stories';
  }

  createSlide() {
    this.bsModal.currentModal = '#slide-name-modal';
    this.bsModal.openModal({
      backdrop: true,
      keyboard: false
    });
  }

  public createSlideWithName(name){

    console.log('createSlideWithName', name);

    if (name && name.length > 0) {

      console.log('createSlideWithName', name.length);


      if (this.getSlideByName(name)) {
        console.log('createSlideWithName:: this.getSlideByName(name)', this.getSlideByName(name));
        window.alert(Yiit.t("Name is already taken"));
        return;
      }
      let slide = new Slide(name, this.slides.length + 1);
      console.log('createSlideWithName:: slide', slide);
      this.readCameraPosition(slide, true).then(async ()=>{
        console.log('createSlideWithName:: readCameraPosition', slide);
        let config:any = await this.storyAdapter.getCurrentConfigAsync();
        config.bounds = await this.cesiumAdapterService.getViewRectangleAsync();
        console.log('****** config', config);
        slide.setEnvironment(config);
        this.slides.push(slide);
        console.log('****** createSlideWithName');
        this.saveStory(()=>{
          this.updateSliders();
        });
        this.cd.detectChanges();
      });
    }
  }

  createShot() {
    this.setState('shot-loading');
    let slide = new Slide('preview', this.slides.length + 1);
    this.readCameraPosition(slide, true)
      .then(async dataURL => {
        this.previewImage = dataURL;
        this.setState('shot-done');
        let config:any = await this.storyAdapter.getCurrentConfigAsync();
        slide.setEnvironment(config);
        this.previewSlide = slide;
        this.cd.detectChanges();
      });
    // this.slides.push(slide);
    // this.saveStory();
  }

  replaceSlide(slide:Slide, cb?){
    //{type: 'image/jpeg', quality: .2}
    this.cesiumAdapterService.createScreenshot().then((dataURL) => {
      slide.image = dataURL;
      this.saveStory();
      if (cb){cb(slide)}
    });
  }

  cancelShot() {
    this.previewImage = null;
    this.setState('default');
  }

  createStoryWithPreview() {
    let story = new Story();
    if (this.previewSlide) {
      story.slides.push(this.previewSlide);
    }
    this.storyAdapter.addStory = story;
    this.currentStory = story;
    this.setState('story');
  }

  createStory() {
    this.preload.preloadMessage$ = this.Yiit.t('Saving Presentation');
    this.preload.isPreloading$ = true;
    let story = new Story('Presentation-'+(this.storyAdapter.generateStoryCount()), this.storyAdapter.generateStoryId());
    if (!story.id){
      story.id = this.storyAdapter.generateStoryId();
    }
    this.storyAdapter.addStory = story;
    // this.setState('story');
    // console.log('this.currentStory', this.currentStory);
    this.saveStory(()=>{
      this.currentStory = this.stories[this.stories.length - 1];
      this.preload.isPreloading$ = false;
      this.cd.detectChanges();
    });
    this.cd.detectChanges();
  }

  isCurrentStory(story){
    return this.currentStory.id.toString() == story.id.toString();
  }

  setStoryEditable(story){
    console.error('story', story)
    if (!this.isEditableStoryArr.includes(story)){
      this.isEditableStoryArr.push(story);
      this.cd.detectChanges();
      timer(200).subscribe(()=>{
        console.log('story.id', story.id);
        console.log('story.id element', document.querySelector('.es-story-'+story.id));
        console.log('story.id input element', document.querySelector('.es-story-'+story.id+' input'));
        let storyElement:any = document.querySelector('.es-story-'+story.id+' input');
        console.log('storyElement', storyElement);
        storyElement.focus();
        storyElement.select();
      });
    }
  }

  toggleEditableStory(story){
    if (this.isEditableStoryArr.includes(story)){
      this.isEditableStoryArr.splice(this.isEditableStoryArr.indexOf(story), 1);
    }
    else{
      this.isEditableStoryArr.push(story);
      timer(100).subscribe(()=>{
        let storyElement:any = document.querySelector('.es-story-'+story.id+' input');
        storyElement.focus();
        storyElement.select();
      });
    }
    this.cd.detectChanges();
  }

  isEditableStory(story){
    return this.isEditableStoryArr.some(_story => +_story.id === +story.id);
  }

  endEditingStory(story, event){
    if (this.isEditableStory(story)){
      this.isEditableStoryArr.splice(this.isEditableStoryArr.indexOf(story), 1);
      this.isOpenedEditList = false;
      this.cd.detectChanges();
    }
    this.saveStory();
  }

  addPreviewToStory(story: Story) {
    if (this.previewSlide) {
      story.slides.push(this.previewSlide);
    }
    this.storyAdapter.addStory = story;
    this.setState('story');
  }

  addPreviewToCurrentStory() {
    if (this.previewSlide && this.currentStory) {
      this.currentStory.slides.push(this.previewSlide);
    }
    this.setState('story');
    this.saveStory();
  }

  addToStory() {
    this.storySearchPhrase = '';
    this.setState('stories-for-preview');
  }

  toggleStories(flag?){
    if (flag){
      this.setState('stories');
      this.activeTab = 'stories';
      this.reInitCurrentStory();
    }
    else{
      this.setState('default');
      this.activeTab = null;
    }
  }

  hideStories(){
    this.setState('default');
    this.activeTab = null;
    this.storyAdapter.setStoriesTabStatus(false);
  }

  showStories() {
    this.setState('stories');
  }

  setCurrentStory(story){
    this.storyAdapter.currentStory$ = story;
    this.cd.detectChanges();
  }

  selectStoriesForPreview(story){
    this.currentStory = story;
    this.addPreviewToCurrentStory();
  }

  downloadSlide(slide:Slide, event?){
    if (event){
      event.preventDefault();
      event.stopPropagation();
    }

    if (slide.config){
      this.applyCameraConfig(slide.config);
      timer(600).subscribe(()=>{
        this.replaceSlide(slide, ()=>{
          saveAs(this.dataURItoBlob(slide.image), window['EVENT_CONFIG']['name'] + ' ' + (new Date()).toLocaleString() + '.png');
          this.legend(slide);
        });
      });
    }
  }

  legend(slide: Slide) {
    this.getLegendImageForSlide(slide, (im) => {
      saveAs(im, slide.name + '_legend.png');
    });
  }

  getLegendImageForSlide(slide: Slide, cb, base64?) {
    if (slide.config){
      const legendListener = () => {
        let items = this.itemManagerService.getVisibleItemLegend(this.cesiumAdapterService.getViewRectangle());
        let canvas = document.createElement('canvas');
        canvas.height = items.length * 50 + 50;
        let ctx = canvas.getContext('2d');
        ctx.font = '20px serif';
        let loadedC = 0;
        let maxWidth = 0;
        for (let i = 0; i < items.length; i++) {
          let tool = this.toolsService.getToolById(items[i].toolId);
          if (!tool) {
            continue;
          }
          maxWidth = Math.max(ctx.measureText(items[i].title).width, maxWidth);
        }
        canvas.width = maxWidth + 100;
        ctx = canvas.getContext('2d');
        ctx.font = '20px serif';
        for (let i = 0; i < items.length; i++) {
          let tool = this.toolsService.getToolById(items[i].toolId);
          console.log(tool);
          if (!tool) {
            continue;
          }
          let img = document.createElement('img');
          img.style.maxHeight = '50px';
          img.style.maxWidth = '50px';
          img.crossOrigin = "anonymous";
          img.setAttribute('crossorigin', 'anonymous');
          let to = setTimeout(() => {
            loadedC++;
            if (loadedC == items.length) {
              cb(base64 ? canvas.toDataURL() : this.dataURItoBlob(canvas.toDataURL()));
            }
          }, 2000);
          img.onload = () => {
            clearTimeout(to);
            let max = Math.max(img.width, img.height);
            let r = max / 45;
            ctx.drawImage(img, 10, 10 + i * 50 + (45 - Math.round(img.height / r)) / 2, Math.round(img.width / r), Math.round(img.height / r));
            loadedC++;
            if (loadedC == items.length) {
              cb(base64 ? canvas.toDataURL() : this.dataURItoBlob(canvas.toDataURL()));
            }
          };
          img.src = tool.menu_icon ? tool.menu_icon : tool.map_icon;
          ctx.fillText(items[i].title, 70, 40 + i * 50);
        }
        if (items.length == 0) {
          cb(base64 ? canvas.toDataURL() : this.dataURItoBlob(canvas.toDataURL()));
        }

        console.log('legend', items);
        // this.cesiumAdapterService.viewer.scene.postRender.removeEventListener(legendListener);
      };
      this.applyCameraConfig(slide.config);
      timer(600).subscribe(()=> {
        legendListener();
        // this.cesiumAdapterService.viewer.scene.postRender.addEventListener(legendListener);
      });
    }
  }

  downloadShot() {
    saveAs(this.dataURItoBlob(this.previewImage), window['EVENT_CONFIG']['name'] + ' ' + (new Date()).toLocaleString() + '.png');
    this.setState('default');
    this.showCaptureBtn = false;
    this.showDownloadedTooltip();
  }

  showDownloadedTooltip() {
    this.downloadedTooltipVisible = true;
    setTimeout(() => {
      this.downloadedTooltipVisible = false;
    }, 3000);
  }
  showGroupSavedTooltip() {
    this.groupTooltipVisible = true;
    setTimeout(() => {
      this.groupTooltipVisible = false;
    }, 3000);
  }

  showCopiedTooltip() {
    this.copiedTooltipVisible = true;
    setTimeout(() => {
      this.copiedTooltipVisible = false;
    }, 3000);
  }

  async choose(s:Slide, event?) {
    if (event){
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    if (this.currentSlide === null) {
      this.backupCurrentConfig();
    } else if (s === null) {
      this.restoreBackupConfig();
    }
    if (s !== null) {
      await this.applyConfigAsync(s.config);
      // this.applyConfig(s.config);
    }
    this.currentSlide = s;
  }

  async saveSlide(s:Slide) {
    let config:any = await this.storyAdapter.getCurrentConfigAsync();
    s.setEnvironment(config);
    console.log('****** saveSlide');
    this.saveStory();
  }

  removeSlide(s:Slide, event?) {
    if (event){
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
    if (window.confirm(Yiit.t('Are you sure?'))) {
      for (let i = 0; i < this.slides.length; i++) {
        if (this.slides[i].name == s.name) {
          this.slides.splice(i, 1);
          if (this.currentSlide && s.name == this.currentSlide.name) {
            this.choose(null);
          }
          this.saveStory(()=>{
            this.updateSliders();
          });
          break;
        }
      }
    }
  }

  run() {
    document.querySelector('body').classList.add('story-running');
    this.httpClient.get('/story/start').subscribe((id) => {
      this.presentationId = id;
      this.presentationImages = {};
      this.runSlide(0);
    });
  }

  inputKeyUpDelayed(){
    clearTimeout(this.inputKeyUpTimer);
    this.inputKeyUpTimer = setTimeout(() => {
      this.saveStory();
    }, 750);
  }
  activateInput(input:any){
    $(input).addClass('active').focus().select();
    console.log(input);
  }
  deactivateInput(input:any){
    $(input).removeClass('active');
    this.saveStory();
  }

  generatePresentation(){

    //will fail if story does not exist

    //this.showExportProgress = this.getShowExportProgressFalse;


    console.log('generatePresentation', this.currentStory);

    if(this.currentStory.slides.length < 1){
      alert('This story does not contain any slides.');
      return;
    }


    this.httpClient.post('/story/generate', {
      story_id: this.currentStory.id,
      event_id: window['EVENT_ID'],
    }).subscribe((result)=>{

      console.log('generatePresentation', result, window['GENERATIONS_INSTRUCTIONS']);

      if (!this.presentationsInGeneration.includes(this.currentStory.id)){
        this.presentationsInGeneration.push(this.currentStory.id);
      }

      if (result && window['GENERATIONS_INSTRUCTIONS']){
        console.log('result', result);
        this.bsModal.currentModal = '#generate-presentation-modal';
        this.bsModal.openModal();
      }
      this.cd.detectChanges();
      this.sendCheckGenerationRequest();
    });
  }

  isPresentationGenerating(story){
    return story && story.hasOwnProperty('id') && this.presentationsInGeneration.includes(story.id);
  }

  hasSlides(story){
    return story.slides.length > 0;
  }

  generatePPTX(){
    this.bsModal.currentModal = '#pptx-story-modal';
    this.bsModal.openModal();
  }

  async runSlide(index) {
    if (this.slides.length - 1 < index) {
      //todo: add story_id
      this.httpClient.post('/story/stop', {
        story_id: this.currentStory.id,
        id: this.presentationId,
        images: this.presentationImages,
        event_id: window['EVENT_ID'],
        items: this.itemManagerService.getItemLegend()
      }).subscribe((pdfURL) => {
        console.log('pdfURL', pdfURL);
        alert(Yiit.t("Finished. We'll send story link to your email address."));
        document.querySelector('body').classList.remove('story-running');
      }, (err)=>{
        console.log('error', err);
      });

      return;
    }

    await this.applyConfigAsync(this.slidesSorted[index].config);
    // this.applyConfig(this.slidesSorted[index].config);
    setTimeout(() => {
      this.cesiumAdapterService.createScreenshot().then((dataURL:string) => {
        var img = new Image(100, 200);
        img.src = dataURL;
        img.classList.add('slide-screenshot');
        document.querySelector('body').appendChild(img);

        this.httpClient.post('/story/upload', {
          id: this.presentationId,
          slide: this.slidesSorted[index].name,
          data: dataURL
        }).subscribe((screenshotURL:string) => {
          this.presentationImages[screenshotURL] = this.slidesSorted[index].name;
          img.classList.add('sent');
          setTimeout(() => { this.runSlide(index + 1); }, 1000);
        });
      });
    }, 500)
  }

  readCameraPosition(slide:Slide, doNotSaveStory?) {
    let cameraPosition = this.cesiumAdapterService.getCameraPosition();
    slide.config.cameraLatitude = cameraPosition.latitude;
    slide.config.cameraLongitude = cameraPosition.longitude;
    slide.config.cameraHeight = cameraPosition.height;

    let cameraOrientation = this.cesiumAdapterService.getCameraOrientation();
    slide.config.cameraHeading = cameraOrientation.heading;
    slide.config.cameraPitch = cameraOrientation.pitch;
    slide.config.cameraRoll = cameraOrientation.roll;

    return new Promise((resolve, reject) => {
      this.cesiumAdapterService.createScreenshotJPEG().then((dataURL)=>{
        slide.image = dataURL;
        if (!doNotSaveStory) {
          this.saveStory();
        }
        this.preload.isPreloading$ = false;
        this.cd.detectChanges();
        resolve(dataURL);
      })
    });
  }

  isImageClipboardSupported() {
    // @ts-ignore
    return (typeof(ClipboardItem) == "undefined");
  }

  screenshotClipboard() {
    this.cesiumAdapterService.createScreenshotBlob().then(({blob, base64}) => {
      try {
        if (this.isImageClipboardSupported()) {
          if (confirm(Yiit.t("Your browser does not support copying images into clipboard. Would you like to download the image?"))) {
            this.screenshotDownload();
          } else {
            return;
          }
        }
        // @ts-ignore
        let item = new ClipboardItem({
          'image/png': blob
        });
        // @ts-ignore
        navigator.clipboard.write([item]);
        window.alert(Yiit.t("Copied to clipboard"));
        this.suggestCreatingASlide();
      } catch (error) {
        console.error(error);
      }
    });
  }

  screenshotDownload() {
    this.cesiumAdapterService.createScreenshotBlob().then(({blob, base64}) => {
      try {
        saveAs(blob, window['EVENT_CONFIG']['name'] + ' ' + (new Date()).toLocaleString() + '.png');
        setTimeout(() => { this.suggestCreatingASlide(); }, 3000);
      } catch (error) {
        console.error(error);
      }
    });
  }

  saveGroup(){
    this.saveStory();
    this.currentGroup = null;
    this.showGroupSavedTooltip();
  }

  saveStory(cb?) {
    this.isDisabled = true;
    this.storyAdapter.saveStory(()=>{
      this.reInitCurrentStory();
      if (cb){cb()}
      this.isDisabled = false;
      this.cd.detectChanges();
    })
  }

  updateCurrentStoryName(event){
    this.saveStory();
  }

  private reInitCurrentStory(){
    let found = false;
    for (let i=0; i < this.storyAdapter.stories.length; i++){
      let story = this.storyAdapter.stories[i];
      if (this.currentStory && story.id == this.currentStory.id){
        this.currentStory = story;
        found = true;
        break;
      }
    }
    if (!found) {
      if (this.storyAdapter.stories.length > 0) {
        this.currentStory = this.storyAdapter.stories[0];
      } else {
        this.currentStory = null;
      }
    }
    this.cd.detectChanges();
  }

  isPptxLoaded(story?:Story){
    if (!story){
      story = this.currentStory;
    }
    return this.pptxMap.has(story.id.toString());
  }

  uploadPptx($event) {
    let self = this;
    let file = $event.target.files[0];
    let reader = new FileReader();
    reader.onloadend = function() {
      self.httpClient.post('/story/save-pptx', {
        event_id: window['EVENT_ID'],
        story_id: self.currentStory.id,
        data: reader.result
      }).subscribe((result) => { self.pptxMap.set(self.currentStory.id.toString(), result); self.cd.detectChanges(); console.log("Pptx saved", result)});
    };
    reader.readAsDataURL(file);
  }

  removePPtx(){
      this.httpClient.post('/story/remove-pptx', {
        event_id: window['EVENT_ID'],
        story_id: this.currentStory.id,
      }).subscribe((result) => { this.pptxMap.delete(this.currentStory.id.toString()); this.cd.detectChanges(); console.log("Pptx deleted", result)});
    };


    setupOverlays(e:SlideConfig){

      console.log('**** setupOverlays ****');

      if(typeof e.environment['componentConfigs'] !== 'undefined' && typeof e.environment['componentConfigs']['concreteLayer'] !== 'undefined' && typeof e.environment['componentConfigs']['concreteLayer']['overlay'] !== 'undefined'){
        let concrete_config:any = e.environment['componentConfigs']['concreteLayer'];
        console.log('**** concrete_config', concrete_config);
        this.concreteLayerService.setEnvironmentConfig(concrete_config);
      }
      if(typeof e.environment['componentConfigs'] !== 'undefined' && typeof e.environment['componentConfigs']['concreteLayerService'] !== 'undefined' && typeof e.environment['componentConfigs']['concreteLayerService']['overlay'] !== 'undefined'){
        let concrete_config:any = e.environment['componentConfigs']['concreteLayerService'];
        console.log('**** concrete_config', concrete_config);
        this.concreteLayerService.setEnvironmentConfig(concrete_config);
      }

      let all_available_overlays:any = [];

      for(let i in this.overlayImages){
        all_available_overlays.push(this.overlayImages[i]);
      }
      for(let i in this.overlaysType2){
        all_available_overlays.push(this.overlaysType2[i]);
      }

      for(let i in all_available_overlays){
        let overlay:any = all_available_overlays[i];
        if(typeof e.environment.componentConfigs['overlayService'] !== 'undefined' && typeof e.environment.componentConfigs['overlayService']['layouts'] !== 'undefined'){
          let layouts:any = e.environment.componentConfigs['overlayService']['layouts'];
          if(layouts.length > 0){
            for(let l in layouts){
              let layout:any = layouts[l];
              if(layout.id == overlay.id){
                overlay.isVisible = true;
                overlay.rotation = typeof layout.rotation !== 'undefined' ? layout.rotation : 0;
                console.log('applyCameraConfig overlay', overlay);
                overlay.show();
                this.overlayService.addToVisibleLayouts(overlay);
                this.overlayService.overlayTabs[overlay.id].isVisible = true;
              }
            }
          }
        }
      }
    }

  protected suggestCreatingASlide() {
    if (window.confirm(Yiit.t("Would you like to save this map state for future?"))) {
      this.createSlide();
    }
  }

  protected async applyCameraConfig(e:SlideConfig) {
    // console.log('environment', e.environment);
    // console.log('applyCameraConfig', e);
    // console.log('applyCameraConfig', e.environment.componentConfigs['overlayService']['layouts']);

    this.setupOverlays(e);

    console.log('******* e.environment', e.environment);

    // var rectangleSelector = new Cesium.Rectangle();
    // rectangleSelector.east = e.environment.bounds.east;
    // rectangleSelector.west = e.environment.bounds.west;
    // rectangleSelector.north = e.environment.bounds.north;
    // rectangleSelector.south = e.environment.bounds.south;

    window['oneplanDrawEnvironmentBoundsRect'] = (rect:any = false) => {
      if(!rect){
        rect = e.environment.bounds;
      }
      var tl = Cesium.Cartographic.fromDegrees(rect.east, rect.north, 0);
      var tr = Cesium.Cartographic.fromDegrees(rect.west, rect.north, 0);
      var bl = Cesium.Cartographic.fromDegrees(rect.east, rect.south, 0);
      var br = Cesium.Cartographic.fromDegrees(rect.west, rect.south, 0);
      tl = Cesium.Cartographic.toCartesian(tl);
      tr = Cesium.Cartographic.toCartesian(tr);
      bl = Cesium.Cartographic.toCartesian(bl);
      br = Cesium.Cartographic.toCartesian(br);
      var cartoArr = [bl, br, tr, tl];
      this.cesiumAdapterService.viewer.entities.add({rectangle: {material: Cesium.Color.GREEN.withAlpha(0.4), coordinates: Cesium.Rectangle.fromCartesianArray(cartoArr) } });
      console.log(cartoArr);
      return cartoArr;
    };




    // // @here - need to check if concreteLayer enabled and only run this when true
    // if(typeof e.environment['componentConfigs'] !== 'undefined' && typeof e.environment['componentConfigs']['concreteLayer'] !== 'undefined' && typeof e.environment['componentConfigs']['concreteLayer']['overlay'] !== 'undefined'){
    //   let concrete_config:any = e.environment['componentConfigs']['concreteLayer'];
    //   console.log('**** concrete_config', concrete_config);
    //   this.concreteLayerService.setEnvironmentConfig(concrete_config);
    // }
    if(typeof e.environment.labelsVisible !== 'undefined' && !e.environment.labelsVisible){
      this.storyAdapter.appComponent.hideAllLabels();
    }


    if(typeof e.environment.imageryMode !== 'undefined' && e.environment.imageryMode){

      if(typeof e.environment.imageryMode.nearmap !== 'undefined' && e.environment.imageryMode.nearmap && this.imageryProviderMode == 8){
        this.nearmapService.enable();
        setTimeout(() => {
          this.nearmapService.updateImagery(e.environment.imageryMode.nearmap);
        }, 200);
      }
    }else{
      this.imageryProviderService.selectViewModeById(this.cesiumAdapterService.getDefaultImageryProviderId());
    }

    if(typeof e.environment.greyscale !== 'undefined'){
      this.imageryProviderService.bwToggle.isDayTogglerChecked = e.environment.greyscale;
      this.imageryProviderService.setCurrentViewModeGrayScale(e.environment.greyscale ? 0 : 1);
    }else{
      this.imageryProviderService.bwToggle.isDayTogglerChecked = false;
      this.imageryProviderService.setCurrentViewModeGrayScale(1);
    }
    // let modeName, modeVal
    // this.imageryProviderService.selectViewMode(modeName, modeVal);

    clearTimeout(this.groupVisibilityTimeout);
    this.groupVisibilityTimeout = setTimeout(() => {



      this.storyAdapter.forceHiddenGroups = true;

      //this.gs.forceShowGroupItems();

      if(e.environment.hiddenGroups && e.environment.hiddenGroups.length > 0){
        this.storyAdapter.forceHiddenGroups = e.environment.hiddenGroups.length > 0 ? true : false;
        for(let i in e.environment.hiddenGroups){
          // let group:Group = this.gs.getGroupById(e.environment.hiddenGroups[i]);
          // this.gs.setGroupItemsVisibility(group, false);
          setTimeout(() => {
            console.log('forceHideGroupItemsByGroupId', e.environment.hiddenGroups[i].config.groupId);
            this.gs.forceHideGroupItemsByGroupId(e.environment.hiddenGroups[i].config.groupId);
          }, 100);
        }
      }

      this.cd.detectChanges();

      if (e.environment.hasOwnProperty('groupLabelsVisibility') && e.environment.groupLabelsVisibility != undefined){
        timer(500).subscribe(()=>{
          this.gs.setGroupLabelsVisibilityByEnvironmentConfig(e.environment.groupLabelsVisibility);
          this.cd.detectChanges();
        })
      }
    }, 750);

    // console.log('applyCameraConfig -- all_available_overlays', all_available_overlays);
    // console.log('applyCameraConfig -- overlayImages', this.overlayImages);
    // console.log('applyCameraConfig -- overlaysType2', this.overlaysType2);

    //getOverlayImages
    //getOverlaysType2
    //addToVisibleLayouts(item:Overlay)
    // this.overlayService
    //here
    // let orientation:any = {
      //   heading: Cesium.Math.toRadians(0),
      //   pitch: Cesium.Math.toRadians(-90),
      //   roll: 0.0,
      // };

      let orientation:any = e.getCameraOrientation();
      console.log('orientation', orientation);

      if(typeof e.environment.timeline !== 'undefined' && e.environment.timeline && e.environment.timeline.visible){

        console.log('e.environment.timeline222', e.environment.timeline, e.environment.timeline.visible);

        if (window.hasOwnProperty('oneplanSetTimelineToTime')) {
          window['oneplanSetTimelineToTime'](e.environment.timeline.time);
        }
      }else{
        if (window.hasOwnProperty('oneplanRemoveTimeline')) {
          window['oneplanRemoveTimeline']();
        }
      }

    if (e.hasCameraPosition()) {
      this.cesiumAdapterService.setupCamera(e.getCameraPosition(), e.getCameraOrientation());
    }
    if (typeof e.environment.labelsVisible == 'undefined' || e.environment.labelsVisible){
      this.storyAdapter.appComponent.showAllLabels();
    }
    // if(typeof e.environment['componentConfigs'] !== 'undefined' && typeof e.environment['componentConfigs']['fl'] !== 'undefined' && typeof e.environment['componentConfigs']['fl']['fixed_layers'] !== 'undefined' && typeof e.environment['componentConfigs']['fl']['fixed_layers']['visible'] !== 'undefined'){

    //   // let fixed_config:any = e.environment['componentConfigs']['fl'];
    //   // console.log('**** fixed_config', fixed_config);
    //   // await this.fixedLayerAdapter.setEnvironmentConfigAsync(fixed_config);

    // }

  }

  protected async applyCameraConfigAsync(e:SlideConfig) {
    return new Promise(async (resolve, reject) => {

      // if(typeof e.environment.labelsVisible !== 'undefined' && !e.environment.labelsVisible){
      //   this.storyAdapter.appComponent.hideAllLabels();
      // }

      console.log('******* e.environment', e.environment);

      this.setupOverlays(e);

      // var rectangleSelector = new Cesium.Rectangle();
      // rectangleSelector.east = e.environment.bounds.east;
      // rectangleSelector.west = e.environment.bounds.west;
      // rectangleSelector.north = e.environment.bounds.north;
      // rectangleSelector.south = e.environment.bounds.south;

      window['oneplanDrawEnvironmentBoundsRect'] = (rect:any = false) => {
        if(!rect){
          rect = e.environment.bounds;
        }
        var tl = Cesium.Cartographic.fromDegrees(rect.east, rect.north, 0);
        var tr = Cesium.Cartographic.fromDegrees(rect.west, rect.north, 0);
        var bl = Cesium.Cartographic.fromDegrees(rect.east, rect.south, 0);
        var br = Cesium.Cartographic.fromDegrees(rect.west, rect.south, 0);
        tl = Cesium.Cartographic.toCartesian(tl);
        tr = Cesium.Cartographic.toCartesian(tr);
        bl = Cesium.Cartographic.toCartesian(bl);
        br = Cesium.Cartographic.toCartesian(br);
        var cartoArr = [bl, br, tr, tl];
        this.cesiumAdapterService.viewer.entities.add({rectangle: {material: Cesium.Color.GREEN.withAlpha(0.4), coordinates: Cesium.Rectangle.fromCartesianArray(cartoArr) } });
        console.log(cartoArr);
        return cartoArr;
      };




      // @here - removed temp for studio
      // if(typeof e.environment['componentConfigs'] !== 'undefined' && typeof e.environment['componentConfigs']['concreteLayer'] !== 'undefined' && typeof e.environment['componentConfigs']['concreteLayer']['overlay'] !== 'undefined'){
      //   let concrete_config:any = e.environment['componentConfigs']['concreteLayer'];
      //   console.log('**** concrete_config', concrete_config);
      //   await this.concreteLayerService.setEnvironmentConfigAsync(concrete_config);
      // }

      if (typeof e.environment.labelsVisible == 'undefined' || e.environment.labelsVisible){
        this.storyAdapter.appComponent.showAllLabels();
      }

      if(typeof e.environment.imageryMode !== 'undefined' && e.environment.imageryMode && e.environment.imageryMode.mode){
        //console.log('e.environment 67887667887667887667876', e.environment);
        //console.warn('environment.imageryMode.mode', e.environment.imageryMode.mode);

        this.prevSelectedModeVal = e.environment.prevSelectedModeVal;
        this.prevSelectedModeName = e.environment.prevSelectedModeName;
        this.imageryProviderMode = e.environment.imageryMode.mode;
        this.imageryProviderName = e.environment.imageryMode.name;

        if(e.environment.imageryMode.mode == '-1'){
          this.imageryProviderService.selectViewModeById(this.prevSelectedModeVal);
        } else {
          this.imageryProviderService.selectViewModeById(this.imageryProviderMode);
        }


      }else{
        this.imageryProviderService.selectViewModeById(this.cesiumAdapterService.getDefaultImageryProviderId());
      }
      if(typeof e.environment.greyscale !== 'undefined'){
        this.imageryProviderService.bwToggle.isDayTogglerChecked = e.environment.greyscale;
        this.imageryProviderService.setCurrentViewModeGrayScale(e.environment.greyscale ? 0 : 1);
      }else{
        this.imageryProviderService.bwToggle.isDayTogglerChecked = false;
        this.imageryProviderService.setCurrentViewModeGrayScale(1);
      }
      // let modeName, modeVal
      // this.imageryProviderService.selectViewMode(modeName, modeVal);

      this.gs.forceShowGroupItems();

      // console.log('applyCameraConfig -- all_available_overlays', all_available_overlays);
      // console.log('applyCameraConfig -- overlayImages', this.overlayImages);
      // console.log('applyCameraConfig -- overlaysType2', this.overlaysType2);

      //getOverlayImages
      //getOverlaysType2
      //addToVisibleLayouts(item:Overlay)
      // this.overlayService
      //here
      // let orientation:any = {
        //   heading: Cesium.Math.toRadians(0),
        //   pitch: Cesium.Math.toRadians(-90),
        //   roll: 0.0,
        // };

        let orientation:any = e.getCameraOrientation();
        console.log('orientation', orientation);

        if(typeof e.environment.timeline !== 'undefined' && e.environment.timeline && e.environment.timeline.visible){

          console.log('e.environment.timeline', e.environment.timeline);

          if (window.hasOwnProperty('oneplanSetTimelineToTime')) {
            window['oneplanSetTimelineToTime'](e.environment.timeline.time);
          }
        }else{
          if (window.hasOwnProperty('oneplanRemoveTimeline')) {
            window['oneplanRemoveTimeline']();
          }
        }


      clearTimeout(this.groupVisibilityTimeout);
      let promise = new Promise((resolve)=>{
        this.groupVisibilityTimeout = setTimeout(() => {

          //this.storyAdapter.forceHiddenGroups = true;

          if(e.environment.hiddenGroups && e.environment.hiddenGroups.length > 0){
            this.storyAdapter.forceHiddenGroups = e.environment.hiddenGroups.length > 0 ? true : false;
            for(let i = 0; i < e.environment.hiddenGroups.length; i++){
              let group:Group = this.gs.getGroupById(e.environment.hiddenGroups[i]);
              if (group){
                this.gs.setGroupItemsVisibility(group, false);
              }
              setTimeout(() => {
                this.gs.forceHideGroupItemsByGroupId(e.environment.hiddenGroups[i]);
              }, 100);
            }
          }

          if (e.environment.hiddenItems && e.environment.hiddenItems.length > 0){
            e.environment.hiddenItems.forEach((id)=>{
              let item = this.itemManagerService.getItemById(id);
              if (item){ item.setVisibility(false); }
            })
          }

          if (e.environment.hasOwnProperty('groupLabelsVisibility') && e.environment.groupLabelsVisibility != undefined){
            this.gs.setGroupLabelsVisibilityByEnvironmentConfig(e.environment.groupLabelsVisibility);
            this.cd.detectChanges();
          }
          resolve();
          this.cd.detectChanges();

          if(typeof e.environment.labelsVisible !== 'undefined' && !e.environment.labelsVisible){
            this.storyAdapter.appComponent.hideAllLabels();
            this.cd.detectChanges();
          }
        }, 750);
      })

      await promise;

      if (e.hasCameraPosition()) {
        this.cesiumAdapterService.setupCamera(e.getCameraPosition(), e.getCameraOrientation());
      }

      if(typeof e.environment['componentConfigs'] !== 'undefined' && typeof e.environment['componentConfigs']['fl'] !== 'undefined' && typeof e.environment['componentConfigs']['fl']['fixed_layers'] !== 'undefined' && typeof e.environment['componentConfigs']['fl']['fixed_layers']['visible'] !== 'undefined'){

        // temp removed for studio
        // let fixed_config:any = e.environment['componentConfigs']['fl'];
        // console.log('**** fixed_config', fixed_config);
        // await this.fixedLayerAdapter.setEnvironmentConfigAsync(fixed_config);
      }
      resolve(true);
    });
  }

  protected async applyConfig(e:SlideConfig) {
    // this.applyCameraConfig(e);
    await this.applyCameraConfigAsync(e);
    this.environmentComponents.forEach((componentName) => {
      if (this.hasOwnProperty(componentName) && e.environment.hasComponentConfig(componentName) && e.environment.getComponentConfig(componentName)) {
        if(typeof this[componentName].setEnvironmentConfig !== 'undefined') this[componentName].setEnvironmentConfig(e.environment.getComponentConfig(componentName));
      }
    });
  }

  protected applyConfigAsync(e:SlideConfig) {
    return new Promise(async (resolve, reject) => {
      console.log('applyConfigAsync START');
      for (let i = 0; i < this.environmentComponents.length; i++) {
        let componentName = this.environmentComponents[i];
        let _has_prop:any = this.hasOwnProperty(componentName);
        let _config:any = e.environment.getComponentConfig(componentName);
        let _has_config:any = e.environment.hasComponentConfig(componentName);
        if (componentName == 'concreteLayerService') {

          console.log('applyConfigAsync::e.environment', e.environment);

          _config = e.environment['componentConfigs']['concreteLayer'];
          if(_config){
            _has_config = true;
          }
        }

        console.log('applyConfigAsync::componentName', componentName);
        console.log('applyConfigAsync::_has_prop', _has_prop);
        console.log('applyConfigAsync::_has_config', _has_config);
        console.log('applyConfigAsync::_config', _config);
        if (_has_prop && _has_config && _config) {
          console.log('applyConfigAsync 1');
          console.log('applyConfigAsync 1 componentName', componentName, e.environment.hasComponentConfig('fl'), typeof e.environment['componentConfigs']['fl'] !== 'undefined');
          if (componentName == 'concreteLayerService' && (typeof e.environment['componentConfigs']['fl'] !== 'undefined' || e.environment.hasComponentConfig('fl'))) {
            console.log('applyConfigAsync 2');
            for (let i = 0; i < e.environment['componentConfigs']['fl']['fixed_layers']['visible'].length; i++) {
              let c = JSON.parse(JSON.stringify(_config));
              c.fixedLayerId = e.environment['componentConfigs']['fl']['fixed_layers']['visible'][i];
              this[componentName].setEnvironmentConfig(c, false);
            }
            let c = JSON.parse(JSON.stringify(_config));
            c.fixedLayerId = e.environment['componentConfigs']['fl']['fixed_layers']['selected'];
            this[componentName].setEnvironmentConfig(c);
          } else {
            console.log('applyConfigAsync 3');
            if(typeof this[componentName].setEnvironmentConfig !== 'undefined') {
              console.log('applyConfigAsync 4');
              // this[componentName].setEnvironmentConfig(_config);
            }
          }
          let start = Date.now();
          while (!window['isRendered'](2000)) {
            console.log('inside is rendered');
            await (new Promise(r => setTimeout(r, 1000)));
            if (Date.now() - start > 60000) { break; }
          }
        }
      }
      await this.applyCameraConfigAsync(e);
      // await (new Promise(r => setTimeout(r, 5000)));
      console.log('applyConfigAsync END');
      resolve(true);
    });
  }

  // protected applyConfigAsync(e:SlideConfig) {
  //   return new Promise(async (resolve, reject) => {
  //     this.environmentComponents.forEach((componentName) => {
  //       if (this.hasOwnProperty(componentName) && e.environment.hasComponentConfig(componentName) && e.environment.getComponentConfig(componentName)) {
  //         if(typeof this[componentName].setEnvironmentConfig !== 'undefined') this[componentName].setEnvironmentConfig(e.environment.getComponentConfig(componentName));
  //       }
  //     });
  //     await this.applyCameraConfigAsync(e);
  //     resolve(true);
  //   });
  // }

  protected async getCurrentConfig() {
    let e = new EnvironmentConfig();
    this.environmentComponents.forEach((componentName) => {
      if (this.hasOwnProperty(componentName)) {
        e.addComponentConfig(componentName, this[componentName].getEnvironmentConfig());
      }
    });
    return e;
  }

  protected async backupCurrentConfig() {
    let c = new SlideConfig();
    let config:any = await this.storyAdapter.getCurrentConfigAsync();
    c.environment.assign(config);
    this.backupConfig = c;
  }

  protected async restoreBackupConfig() {
    if (this.backupConfig) {
      await this.applyConfigAsync(this.backupConfig);
      //this.applyConfig(this.backupConfig);
      this.backupConfig = null;
    }
  }

  protected getSlideByName(name) : Slide {
    for (let i = 0; i < this.slides.length; i++) {
      if (this.slides[i].name === name) {
        return this.slides[i];
      }
    }
    return null;
  }

  ngAfterViewInit(): void {
    // this.subscribeToObservable(this.gs.onGroupVisibilityUpdated.pipe(filter(config => config.group.getId() == this.item.getId())), (({group, visibility})=>{
    //   this.isItemsVisible = visibility;
    //     this.currentChildrenList.forEach((i)=>{
    //       if (i instanceof Item){
    //         i.setVisibility(visibility);
    //       }
    //       if (i instanceof Group){
    //         this.gs.setGroupItemsVisibility(i, visibility);
    //       }
    //     });
    //   this.cd.detectChanges();
    // }))
    // this.gs.onGroupVisibilityUpdated.subscribe(
		// 	res => {
    //     this.groupVisibility[res.group['id']] = res;
    //     let hiddenGroups:any = [];
    //     for(let i in this.groupVisibility){
    //       if(!this.groupVisibility[i].visibility){
    //         hiddenGroups.push(this.groupVisibility[i]);
    //       }
    //     }
    //     this.storyAdapter.setHiddenGroups(hiddenGroups);
    //     console.log('onGroupVisibilityUpdated', res);
		// 	}
		// );
  }

  checkScrollbars(elem:any, attempts:any=0){
    if(attempts > 50){
      return;
    }
    let element:any = document.querySelector(elem);
    console.log('checkScrollbars', elem, element);
    if(element){
      const ps = new PerfectScrollbar(element);
      this.scrollbars.push(ps);
      console.log('checkScrollbars ps', ps);
      // element['fakeScroll']('.es-scrollbar', true);
    }else{
      setTimeout(() => {
        attempts++;
        this.checkScrollbars(elem, (attempts+1));
      }, 500);
    }
  }
  setDrawingToolsInstance(drawingEditorToolsComponent): void {
    drawingEditorToolsComponent.sidebarState.subscribe(closed => {
      this.sidebarOpened = !closed;
      this.setBarWidth();
    });
  }

  dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    var ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([ab], {type: mimeString});
    return blob;

  }

  toggleOpenEditListForStory($event: boolean, story: Story) {
      this.openedStory = story;
      if ($event){
        let element = document.querySelector('.es-story-'+story.id);
        this.editingListPosition = {top:element.getBoundingClientRect().top+element.clientHeight+'px', left: element.getBoundingClientRect().left+element.clientWidth-60+'px'}
        this.openedStory = story;
      }
    this.isOpenedEditList = $event;
  }
}
